<template>
  <div class="content if-profile report-tab">
    <div class="md-layout industry-sumnary">
      <SPIFReportHeader :headerData="this.headerData"/>

      <div class="md-layout-item p-0">
        <md-card>
          <div class="md-layout md-card if_card">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header md-card-header-icon">
                Your Industry Peer Group
              </md-card-header>
              <div class="md-card-content">
                <div class="extra_space">
                  <p>
                    When you accessed your Industry Financial Report, you
                    selected a comparison peer group that most closely
                    represents the character of your firm.
                  </p>
                </div>
                <div class="md-layout px-4">
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <table-card class="md_table mt-0">
                      <template slot="header" header-color="rose">
                        <!--<div class="card-icon">
                            <md-icon>addchart</md-icon>
                          </div>-->
                        <h4 class="title m-0">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                          >
                            Firms Analyzed
                          </div>
                        </h4>
                      </template>
                      <template slot="content">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableData">
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell md-label="Profile Year">{{
                                item.year
                              }}</md-table-cell>
                              <md-table-cell md-label="Firms">{{
                                item.firms
                              }}</md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </template>
                    </table-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <chart-card
                      header-animation="false"
                      :chart-data="colouredLineChart.data"
                      :chart-options="colouredLineChart.options"
                      chart-type="Bar"
                      header-icon
                      chart-inside-content
                      no-footer
                      background-color="blue"
                    >
                    </chart-card>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <md-card-content class="p-0">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                <profile-card header-color="blue" class="text-card if_card">
                  <template slot="header"
                    >Your Industry In Context: The NAICS Classification
                    System</template
                  >
                  <template slot="content">
                    <div class="extra_space">
                      <p>
                        The industry your selected fits within the official
                        NAICS (North American Industry Classification System)
                        and Bizminer’s proprietary taxonomy, which breaks out
                        more detailed industries classifications than NAICS by
                        adding up to eight decimal digits after the NAICS-6
                        code. The industry you selected fits into this industry
                        hierarchy:
                      </p>
                      <ul>
                        <li v-for="(value, key) in naicsDrilldown" :key="key">
                          NAICS: {{ key }} - {{ value }}
                        </li>
                      </ul>
                    </div>
                  </template>
                </profile-card>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, TableCard, ProfileCard } from '@/components';
import { mapState } from 'vuex';
import SPIFReportHeader from './_partials/SPIFHeader.vue';

export default {
  components: {
    SPIFReportHeader,
    ChartCard,
    TableCard,
    ProfileCard,
  },
  props: ['headerData'],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          // lineSmooth: this.$Chartist.Interpolation.cardinal({
          //   tension: 10,
          // }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '200px',
        },
      },
      tableData: [],
      filtered_years: ['"Firms Analyzed"'],
      filtered_firms: [''],
      convertData: [],
    };
  },
  computed: {
    ...mapState({
      report: (state) => state.user.report.data,
      naicsDrilldown: (state) => state.user.report.data['naicsDrilldown'],
      showYears: (state) => state.user.report.data.showYears,
      years: (state) => state.user.report.data.years,
      PLtable: (state) => state.user.report.data.tables['PL'],
      // BStable: state => state.user.report.tables['BS'],
    }),
    filteredProfile() {
      return _.omit(this.report.data, 'array_customer');
    },
    getCsvData() {
      let csvData = [
        ['Industrial Financial Report'],
        ['"Release Date"', '"Aug 2021"'],
        [''],
        ['Segment', 'Industry'],
        ['Plumbing,Heating and Air-Conditioning Contractors'],
        ['[238220] Sector', 'Construction'],
        ['Market', 'Harrisburg Metro Area'],
        ['Sales Class', '1$-2.49$'],
        [''],
      ];
      csvData.push(this.filtered_years);
      csvData.push(this.filtered_firms);
      csvData.push(['']);
      csvData.push([
        'Income and Expense - Profit and Loss($)',
        '',
        '',
        '',
        '',
        'Your Firm',
        '',
        '',
        'Variance',
      ]);
      csvData.push([
        '',
        2016,
        2017,
        2018,
        '',
        '',
        '',
        2016,
        2017,
        2018,
        '',
        '',
        '',
        2016,
        2017,
        2018,
      ]);
      return csvData;
    },
  },
  mounted() {
    let filtered_years = [];
    let me = this;

    this.convertData.push({
      items: Object.keys(this.PLtable),
    });

    if (this.showYears) {
      Object.keys(this.showYears).map((k) => {
        // this.showYears.forEach((s, i) => {

        if (this.showYears && this.showYears[k]) {
          filtered_years.push(this.years[k]);
        }
      });
    }
    if (!filtered_years.length) {
      filtered_years = this.years;
    }
    filtered_years.forEach((s, i) => {
      this.filtered_years.push(Number(s));
    });
    this.tableData = Object.values(this.filteredProfile).filter((item) => {
      if (filtered_years.includes(item.year)) {
        return {
          ...item,
          firms: item.firms,
        };
      }
    });
    this.tableData.forEach((element) => {
      if (filtered_years.includes(element.year)) {
        this.filtered_firms.push(Number(element.firms));
      }
    });
    this.tableData = this.tableData.map((item) => {
      return {
        ...item,
        firms: me.numberWithCommas(item.firms),
      };
    });

    this.tableData = _.orderBy(this.tableData, ['year'], ['asc']);
    let seriesFilter = [];
    Object.values(this.filteredProfile).forEach((item, index) => {
      if (filtered_years.includes(item.year)) {
        seriesFilter.push(item.firms);
      }
    });
    if (!seriesFilter.length) {
      seriesFilter = Object.values(this.filteredProfile).map(
        (item) => item.firms
      );
    }
    this.colouredLineChart.data = {
      labels: filtered_years,
      series: [seriesFilter],
    };
  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'csvData.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.industry-sumnary {
  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  h4.main-street {
    margin-top: 0;
  }
}
</style>
